import {Grid2, Typography} from "@mui/material";
import * as React from "react";
import GalleryCarousel from "@/pages/landing-page/utils/GalleryCarousel";
import {Section5DTO} from "@/pages/landing-page/landing-page-data";
import {LANDING_HEADLINE} from "@/pages/landing-page/utils/landing-font-sizes";
import {COMPACT_SECTION_MIN_HEIGHT} from "@/pages/landing-page/utils/landing-section-layout";
import {compactValue} from "@/lib/screen-class";

interface Section5Props {
    data: Section5DTO;
}

export const Section5 = ({ data }: Section5Props) => (
    <Grid2
        container
        direction="column"
        paddingTop={4}
        sx={{
            minHeight: COMPACT_SECTION_MIN_HEIGHT,
            // backgroundColor: color_grey[4],
            position: "relative",
            px: {
                md: 1,
                lg: 10
            }
        }}
    >
        <Grid2 width="100%" paddingBottom={compactValue(2, 10)}>
            <Typography sx={{ fontSize: LANDING_HEADLINE }} fontWeight="700" width="fit-content">
                {data.title}
            </Typography>
        </Grid2>

        <Grid2 width="100%">
            <GalleryCarousel items={data.testimonies} />
        </Grid2>
    </Grid2>
);
